IREP.spinTheWheel = (function () {
    var self = this;
    var spinEnabled = true;

    var degrees = {
        '1': 0,
        '2': 330,
        '3': 300,
        '4': 270,
        '5': 240,
        '6': 210,
        '7': 180,
        '8': 150,
        '9': 120,
        '10': 90,
        '11': 60,
        '12': 30
    };

    var shift = function () {
        $('#stw-fade').toggleClass('stw-fade');
        $('.spinner').toggle();
        $('#spin-settings').toggle();
    };

    var toggleSpinIcon = function () {
        spinEnabled = true;
        $('.stw-banner').hide();
        $('.spin-icon').toggle();
    };

    var toggleBanner = function () {
        $('.spin-icon').hide();
        $('.stw-banner').toggle();
        var display = $('.stw-banner').css('display');
        spinEnabled = display === 'none';
    };

    var toggleChipsCongrats = function () {
        $('#thanks-chips').toggle();
    };

    var toggleBundleCongrats = function () {
        $('#thanks-bundle').toggle();
    };

    var showCongrats = function () {
        $('.congrats-wrapper').show();
    };

    var hideCongrats = function () {
        $('.congrats-wrapper').hide();
        $('.stw-banner').show();
        $('.spin-icon').hide();
    };

    var spin = function () {
        if (!spinEnabled) return;

        var display = $('.stw-banner').css('display');
        if (display !== 'none') return;

        $('.spin-icon').hide();
        var spinLocation = $('#spinLocation').attr('data-spin-location');
        var duration = (spinLocation / 360) * 2000;

        // This line won't be needed in the actual game
        $('.spin-wheel').animate({ rotate: '0' }, 0, 'linear', function () { });

        $('.spin-wheel').animate({ rotate: '720' }, 1500, 'linear', function () { });
        $('.spin-wheel').animate({ rotate: '360' }, 1000, 'linear', function () { });
        $('.spin-wheel').animate({ rotate: spinLocation }, duration, 'linear', function () {
            //IREP.track("SpinTheWheel", "Spin", 'Spin', '', '');
            var url = window.location.origin + window.location.pathname + '/chips';
            $.ajax({
                dataType: "json",
                url: url,
                contentType: 'application/json',
                type: 'POST',
                headers: { "PaxUID": IREP.options.user.currentUID },
                success: function (data) {
                    console.log(data);
                }
            });
            setTimeout(function () {
                showCongrats();
            }, 1000);
        });
    };

    var init = function () {
        $('#tmpBtnShift').on('click', shift);
        
        $('#btnSpin').on('click', spin);
        $('#btnSpinIcon').on('click', toggleSpinIcon);
        $('#btnToggleBanner').on('click', toggleBanner);
        $('#btnToggleChips').on('click', toggleChipsCongrats);
        $('#btnToggleBundle').on('click', toggleBundleCongrats);


        $('#imgToggleChips').on('click', hideCongrats);
        $('#imgToggleBundle').on('click', hideCongrats);

        $('.spin-wheel-button').on('click', spin);

        $('#submitBundle').on('click', function () {
            var size = $('#shirt-size').val();
            if (size == 'none') {
                alert('Please select a size!');
            } else {
                window.location.href = window.location.origin + window.location.pathname + '/bundle/' + size + window.location.search;
            }
        });
    };

    return {
        init: init
    }
})();